import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <>
      <div className="h-full bg-[#FFFFFF] rounded-[16px] border border-[#E5D9C3] shadow-[0_1px_3px_rgba(74,47,30,0.12)] overflow-hidden hover:shadow-[0_10px_30px_rgba(74,47,30,0.2)] hover:border-[#C9694C] transition-all duration-300 flex flex-col group">
      {/* Image Wrapper */}
      <Link to={`/blog/${item?.slug}`} className="relative block aspect-[16/10] overflow-hidden bg-[#F6EFE2]">
        <img
          src={item?.image}
          alt={item?.title}
          loading="lazy"
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
        />
        {item?.date && (
          <div className="absolute top-3 left-3 bg-[#FFFDF8]/90 backdrop-blur-md text-[#4B3226] text-xs font-semibold px-3 py-1 rounded-[999px] shadow-[0_1px_3px_rgba(74,47,30,0.12)] border border-[#E5D9C3]">
            {getDateAgo(item?.date)}
          </div>
        )}
      </Link>

      {/* Content Wrapper */}
      <div className="p-6 flex flex-col flex-1 justify-between">
        <div>
          <h4 className="text-lg md:text-xl font-bold text-[#4B3226] group-hover:text-[#A6472E] transition-colors mb-3 line-clamp-2 leading-[1.2]">
            {item?.title}
          </h4>
          <p className="text-sm text-[#6B5D53] line-clamp-3 mb-6 leading-[1.6]">
            {item?.shortDescription}
          </p>
        </div>

        {/* Footer */}
        <div className="pt-4 border-t border-[#E5D9C3] mt-auto">
          <Link
            to={`/blog/${item?.slug}`}
            className="inline-flex items-center text-sm font-bold text-[#A6472E] hover:text-[#7A2F1E] transition-colors group/link"
          >
            Read Story{" "}
            <ArrowRight
              size={16}
              className="ml-2 transform group-hover/link:translate-x-1.5 transition-transform duration-200"
            />
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default Card;














